import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { AiReceptionistListRow } from '../../models/AiReceptionist';

export interface AiReceptionistListResponse {
  rows: AiReceptionistListRow[];
  nbHits: number;
}

interface GetCompanyAiReceptionistListPayload {
  company_id: string;
  q: string;
  page: number;
  hitsPerPage: number;
}

export async function getCompanyAiReceptionistList(
  payload: GetCompanyAiReceptionistListPayload,
  auth: Authentication,
): Promise<AiReceptionistListResponse> {
  try {
    if (!payload.company_id) {
      throw new GetCompanyAiReceptionistListFailure('company_id est requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/list', payload, auth.token);

    return response.data as AiReceptionistListResponse;
  } catch (e) {
    console.error('getCompanyAiReceptionistList error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistListFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistListFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistListFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
